module.exports = __webpack_public_path__ + "img/wrinkles-2.8b348617.png";